import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../App";
import { Button } from "../components/ui/button";
import AdminCoursesTab from "../components/AdminCoursesTab";
import { LogOut, ShieldCheck } from "lucide-react";

/**
 * Restricted dashboard for Técnico de Segurança do Trabalho (T.S.T).
 * Has access ONLY to the Cursos area: gerar listas + emitir certificados.
 * No access to contracheques or informes de rendimentos.
 */
const TstDashboard = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-emerald-100 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5 text-emerald-700" />
            </div>
            <div>
              <p className="text-sm font-semibold text-slate-900 leading-tight">
                AVI Segurança — T.S.T
              </p>
              <p className="text-xs text-slate-500">
                {user?.name || "Técnico de Segurança"}
              </p>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={handleLogout}
            data-testid="tst-logout-btn"
          >
            <LogOut className="w-4 h-4 mr-1" />
            Sair
          </Button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <AdminCoursesTab />
        </motion.div>
      </main>
    </div>
  );
};

export default TstDashboard;
